import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
const Banking = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Banking</h6>
          <hr />
          <h1 className="banner-title">
            Revolutionize banking with <br /> advanced analytics and solutions
          </h1>

          <p>
            Leverage advanced analytics to improve decision-making and deliver
            personalized banking experiences.
          </p>

          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/business-person-looking-finance-graphs_23-2150461357.jpg"
          alt="Business Intelligence Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6 className="col_yell text-center">Banking</h6>
              <h2 className="text-center">
                Innovative Banking Solutions for a Connected Future
              </h2>
              <p className="text-center">
                we believe banking should go beyond traditional boundaries. As
                banking services evolve, we help businesses integrate financial
                solutions seamlessly across industries, creating value at every
                touchpoint of the customer journey. Leveraging advanced data
                intelligence, we enable businesses to deliver innovative,
                personalized experiences. Our focus on sustainability and
                inclusivity in banking ensures a future of holistic, long-term
                growth for our clients.
              </p>
            </div>
            {/* <div className="col-md-6">
              <img
                src="https://img.freepik.com/free-photo/business-person-looking-finance-graphs_23-2150461357.jpg"
                alt="Data Engineering"
                className="img-fluid"
              />
            </div> */}
          </div>
        </div>
      </section>
      <hr />

      <div class="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Banking Solutions</h2>
              <p className="text-center mb-0">
                Leverage data analytics to transform banking, improve decisions,
                and enhance customer experiences.
              </p>
            </div>
          </div>
        </div>

        <div class="row g-4">
          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
                <a href="#">Customer Segmentation</a>
              </h3>
              <p class="mb-4">
                Segment customers for personalized solutions and better
                satisfaction.
              </p>
              {/* <a
                href="#"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </a> */}
            </div>
          </div>

          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
                <a href="#">Fraud Detection</a>
              </h3>
              <p class="mb-4">
                Identify and prevent fraudulent transactions in real-time with
                predictive analytics.
              </p>
              {/* <a
                href="#"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </a> */}
            </div>
          </div>

          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
                <a href="#">Loan Default Prediction</a>
              </h3>
              <p class="mb-4">
                Analyze data to predict loan defaults and make data-driven
                lending decisions.
              </p>
              {/* <a
                href="#"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </a> */}
            </div>
          </div>

          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
                <a href="#">Customer Lifetime Value</a>
              </h3>
              <p class="mb-4">
                Predict customer value to focus on long-term relationships and
                growth.
              </p>
              {/* <a
                href="#"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </a> */}
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
                <a href="#">Real-Time Transaction Analytics</a>
              </h3>
              <p class="mb-4">
                Monitor real-time transactions for actionable insights and
                better operations.
              </p>
              {/* <a
                href="#"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </a> */}
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
                <a href="#">Credit Scoring System</a>
              </h3>
              <p class="mb-4">
                Develop advanced credit scoring models for better risk
                assessment.
              </p>
              {/* <a
                href="#"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </a> */}
            </div>
          </div>
        </div>
      </div>

      <hr />

      <section id="about_pg" className="p_3 bg-light">
        <div className="container-xl">
          <h2 class="text-center mt-3">Our Clients</h2>

          <div className="row mt-5">
            <div className="col-md-3 text-center">
              <img
                style={{ maxWidth: "50%", height: "50%" }}
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLCbzTCVEyQLRbPtPgTRZ42Py3RONbjxg54w&s"
                alt=""
              />
            </div>

            <div className="col-md-3 text-center">
              <img
                style={{ maxWidth: "50%", height: "50%" }}
                src="https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/032014/dhaka_bank_logo.png?itok=G4DW7ltu"
                alt=""
              />
            </div>

            <div className="col-md-3 text-center">
              <img
                style={{ maxWidth: "40%", height: "40%" }}
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlbww_ZT11YVd5xDPsnbRF-dUimL7n68x0qw&s"
                alt=""
              />
            </div>
            <div className="col-md-3 text-center">
              <img
                style={{ maxWidth: "30%", height: "30%" }}
                src="https://seeklogo.com/images/U/ucb-bank-logo-DC3AED4E7A-seeklogo.com.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <hr />
      {/* <section id="bi-cta" className="bi-cta text-center py-5">
    <h3>Ready to Transform Your Business with BI?</h3>
    <p>Contact us today to learn how Business Intelligence can unlock your company's potential.</p>
    <a href="#contact" className="btn btn-success mt-3">Get Started</a>
  </section> */}

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="">
                  Ready to Revolutionize Your Banking Operations?
                </h2>
                <p className="mt-3">
                  Let's explore how our data-driven solutions can optimize your
                  banking services, enhance customer experiences, and drive
                  business growth.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/medium-shot-two-colleagues-discussing-business-office_1098-17855.jpg"
                        className="w-100"
                        alt="Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Banking;
